import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('core');

export class CitiesByState extends Api {
  constructor(http, config = {}) {
    super(http, url, 'cities-by-state', config);
  }
}